import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { saveDesign } from "../../actions";
import LoginFormContainer from "./LoginFormContainer";
import LoggedIn from "./LoggedIn";
import CloseIcon from "./../Layout/Icons/CloseIcon";

class LoginWrapper extends React.Component {
  handleOnClick = () => {
    this.props.handleCloseLoginPrompt();
  };

  handleSaveDesign = () => {
    this.props.saveDesign({ savedByCustomer: true });
  };

  render() {
    const loggedComponent = this.props.user.loggedIn ? (
      <LoggedIn
        user={this.props.user}
        handleSaveDesign={this.handleSaveDesign}
        handleOnClick={this.handleOnClick}
      />
    ) : (
      <LoginFormContainer user={this.props.user} />
    );

    return (
      <div className="login-prompt__container">
        <div className="button--close-share" onClick={this.handleOnClick}>
          <CloseIcon />
        </div>

        <div className="login-prompt__content">{loggedComponent}</div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      saveDesign: saveDesign.request,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginWrapper);
